import { i18n } from "/common/client/js/i18n/i18n_instance.js";
export function toggleCustomerFields() {
    const customerNumberGroup = document.getElementById("customerNumberGroup");
    const customerDetailsGroup = document.getElementById("customerDetailsGroup");
    const hasNoCustomerNumberCheckbox = document.getElementById("hasNoCustomerNumber");
    const inputs = customerDetailsGroup.querySelectorAll("input");

    if (hasNoCustomerNumberCheckbox.checked) {
        customerNumberGroup.classList.add("hidden");
        customerDetailsGroup.classList.remove("hidden");
        document.getElementById("customerNumber").value = "";
        document.getElementById("customerNumber").removeAttribute("required");
        inputs.forEach((input) => {
            if (input.id === "customerCompanyEmail") return;
            input.value = "";
            input.setAttribute("required", "true");
        });
    } else {
        customerNumberGroup.classList.remove("hidden");
        customerDetailsGroup.classList.add("hidden");
        inputs.forEach((input) => {
            input.value = "";
            input.removeAttribute("required");
        });
        customerNumberGroup.querySelectorAll('input').forEach((input) => {
            input.setAttribute("required", "true")
        })
    }
}
export function showFormErrors(error, form) {
    if (!error) return console.log('no error');
    if (!error.details) {
        displayFormMessage(error.message, 'error')
        return;
    }
    displayFormMessage('Eingabefehler - bitte überprüfen Sie die markierten Felder und versuchen Sie es erneut.', 'error')

    error.details.forEach(err => {
        let allFields;
        const [_, category, __, field] = err.path;
        const selectors = [
            `[name^="${category}\\["][name$="\\]\\[${field}\\]\\["][name$="\\]"]`,
            `[name*="${err.path.slice(-1)}"]`,
            '.' + err.context.key,
            '#' + err.context.label
        ];
        for (const selector of selectors) {
            allFields = form.querySelectorAll(selector);
            if (allFields.length) break;
        }
        const fildsArray = Array.from(allFields)?.filter(input =>
            input &&
            !input.disabled &&
            !input.closest('.item')?.querySelector('.article-select')?.disabled
        );

        const emptyFields = fildsArray?.filter(f => !f?.value);
        console.log(err.path[0], emptyFields.length)

        if (emptyFields?.length) {
            emptyFields.forEach(emptyField => {
                const errorElement = emptyField.closest('.form-group')?.querySelector('.error') || emptyField.querySelector(':scope > .error') ||
                    createErrorElement(emptyField);
                if (err.path[0].startsWith('appointment')) console.log('errorElement', emptyField.closest('.form-group'))

                errorElement.textContent = i18n.__(err.message);
                errorElement.classList.add('error');
            })
            return;
        }

        if (fildsArray?.length) {
            fildsArray.forEach(targetField => {
                const errorElement = targetField.closest('.form-group')?.querySelector('.error') || targetField.querySelector(':scope > .error') ||
                    createErrorElement(targetField);
                errorElement.textContent = i18n.__(err.message);
                errorElement.classList.add('error');
            })

        }
    });
}
export function restoreFormData(localStorageItem = 'formData') {
    const saved = localStorage.getItem(localStorageItem);
    if (saved) {
        const data = JSON.parse(saved);
        for (let key in data) {
            if (key == "receiptUpload") continue;
            const el = document.querySelector(`[name="${key}"]`);
            if (el) el.value = data[key];
        }
        localStorage.removeItem(localStorageItem);
    }
}
function createErrorElement(field) {
    const div = document.createElement('div');
    div.className = 'error';
    field.closest('.form-group')?.appendChild(div);
    return div;
}
export function clearFormErrors(form) {
    const formMessageDiv = document.getElementById('form-message');
    const errorMessages = form.querySelectorAll('.error');
    errorMessages.forEach(error => error.textContent = '');
    formMessageDiv.classList.remove('error');
    formMessageDiv.textContent = '';
}

export function addRemoveListener(button) {
    const deviceList = button.closest('.devices');
    if (!deviceList) return;

    button.addEventListener('click', function () {
        const items = deviceList.querySelectorAll('.item');
        if (items.length <= 1) {
            alert("You must have at least one device.");
            return;
        }

        // Get the index of the item being removed
        const item = this.closest('.item');
        const indexMatch = item.querySelector('[name^="indoorstations["], [name^="outdoorstations["], [name^="controlUnits["], [name^="others["]')
            ?.name.match(/\[(\d+)\]/);
        const index = indexMatch ? parseInt(indexMatch[1]) : null;

        item.remove();

        // Reindex remaining items if we found an index
        if (index !== null) {
            const categories = ['indoorstations', 'outdoorstations', 'controlUnits', 'others'];
            categories.forEach(category => {
                deviceList.querySelectorAll(`[name^="${category}["]`).forEach(el => {
                    const currentIndex = parseInt(el.name.match(/\[(\d+)\]/)[1]);
                    if (currentIndex > index) {
                        el.name = el.name.replace(
                            /\[(\d+)\]/,
                            `[${currentIndex - 1}]`
                        );
                    }
                });
            });
        }
    });
}
export function hideFormMessage() {
    const formMessageDiv = document.getElementById('form-message');
    formMessageDiv.classList.add('hidden');
    formMessageDiv.textContent = '';
}

export function displayFormMessage(message, type = 'error') {
    const formMessageDiv = document.getElementById('form-message');
    if (!formMessageDiv) return;

    // Clear to ensure re-announcement even for repeated content
    formMessageDiv.textContent = '';

    // Variant classes
    formMessageDiv.className = `form-message ${type}`;

    // Build content
    const icon = document.createElement('span');
    icon.className = 'icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = type === 'success'
        ? `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" width="24" height="24">
         <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
         <path d="M22 4 12 14.01l-3-3"/>
       </svg>`
        : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" width="24" height="24">
         <circle cx="12" cy="12" r="10"></circle>
         <line x1="12" y1="8" x2="12" y2="12"></line>
         <line x1="12" y1="16" x2="12" y2="16"></line>
       </svg>`;

    const content = document.createElement('div');

    const title = document.createElement('p');
    title.className = 'title';
    title.textContent = type === 'success'
        ? 'Vielen Dank für den Auftrag!'
        : 'Es ist ein Fehler aufgetreten';

    const text = document.createElement('p');
    text.className = 'text';
    text.innerHTML = message;

    content.appendChild(title);
    content.appendChild(text);

    formMessageDiv.appendChild(icon);
    formMessageDiv.appendChild(content);

    // Reveal and announce
    formMessageDiv.classList.remove('hidden');
    formMessageDiv.classList.add('show');
}

export function displayLoadingMessage() {
    const submitButton = document.querySelector('.submit-button');
    const loadingMessage = document.getElementById('loadingMessage');
    hideFormMessage()
    submitButton.disabled = true;
    submitButton.classList.add('running')
    loadingMessage.classList.remove('hidden');
}

export function hideLoadingMessage() {
    const loadingMessage = document.getElementById('loadingMessage');
    loadingMessage.classList.add('hidden');
    submitButton.classList.remove('running')
    submitButton.disabled = false;
}

export async function sendFormToServer(body, url) {

    const finalFormData = new FormData();
    finalFormData.append('jsonData', body);

    const fileInput = document.getElementById('receiptUpload');
    if (fileInput.files.length > 0)
        finalFormData.append('receiptUpload', fileInput.files[0]);

    try {
        const response = await fetch(url, {
            method: 'POST',
            body: finalFormData
        });
        
        const data = await response.json();
        return data

    } catch (error) {
        console.error('An error occurred:', error);
        return { success: false, message: error.message }
    }
    finally {
        hideLoadingMessage()
    }
}

export function getFormData(formData) {

    const data = Object.fromEntries(
        Array.from(formData?.entries())?.filter(([key, value]) => {
            const match = key.startsWith('outdoorstations') ||
                key.startsWith('indoorstations') ||
                key.startsWith('others') ||
                key.startsWith('controlUnits') ||
                (key.startsWith('receiptUpload'));
            if (key.startsWith('receiptUpload')) {
            }
            if (match) {
                return false
            }
            return true
        }).map(([key, value]) => {
            if (key.startsWith('customer')) {
                return [key, value.trim() || ''];
            }
            if (key.startsWith('building')) {
                return [key, value.trim() || ''];
            }
            if (value === 'on') {
                return [key, true];
            }
            return [key, value];
        })
    );

    data.devices = {
        indoorstations: processDevices(formData, 'indoorstations'),
        outdoorstations: processDevices(formData, 'outdoorstations'),
        controlUnits: processDevices(formData, 'controlUnits'),
        others: processDevices(formData, 'others')
    };

    return data;
}
const processDevices = (formData, prefix) => {
    const grouped = {};
    const result = [];

    for (const [fullKey, value] of formData.entries()) {
        const match = fullKey.match(
            new RegExp(`${prefix}\\[(\\d+)\\]\\[([^\\]]+)\\](?:\\[(\\d+)\\])?`)
        );
        if (!match) continue;

        const [_, index, field, arrayIndex] = match;
        if (!grouped[index]) grouped[index] = {};

        const device = grouped[index];

        // Convert quantity to number if applicable
        if (field === 'quantity') {
            device.quantity = parseInt(value, 10);
            continue;
        }

        // Handle nested objects like location[floor]
        const isArrayField = typeof arrayIndex !== 'undefined';

        if (isArrayField) {
            if (!device[field]) device[field] = [];
            const i = parseInt(arrayIndex, 10);
            device[field][i] = value;
        } else {
            device[field] = value;
        }
    }

    // Expand quantity into separate device entries
    for (const device of Object.values(grouped)) {
        const quantity = device.quantity || 1;

        for (let i = 0; i < quantity; i++) {
            const entry = {};

            for (const [key, value] of Object.entries(device)) {
                if (key === 'floor' || key === 'apartment') {
                    continue;
                }
                else if (Array.isArray(value)) {
                    entry[key] = value[i] || '';
                } else if (key !== 'quantity') {
                    entry[key] = value;
                }

            }

            // Handle location specially if it's in array form
            if (device.floor || device.apartment) {
                entry.location = {
                    floor: (device.floor && device.floor[i]) || '',
                    apartment: (device.apartment && device.apartment[i]) || ''
                };
            }
            if (entry.articleNumber)
                result.push(entry);
        }
    }

    return result;
};
export function handleFileUpload() {
    document.getElementById('receiptUpload').addEventListener('change', function (e) {
        const fileNameDisplay = document.querySelector('.file-name');
        if (this.files.length > 0 && this.files[0].size) {
            fileNameDisplay.textContent = this.files[0].name;
            fileNameDisplay.style.color = '#111827';
        } else {
            fileNameDisplay.textContent = 'No file selected';
            fileNameDisplay.style.color = '#6b7280';
        }
    });
}